import React, {useEffect, useState} from "react";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import DashboardMenu from "../../../layout/dashboardMenu";
import Loader from "../../../../Loader/Loader";
import {toast} from "react-toastify";

const ApprovalDsmLead = ({
                             getLeadById,
                             match,
                             leadById,
                             leadApprovalAction,
                             leadApprovalResponse = []
                         }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [remark, setRemark] = useState(false);

    useEffect(() => {
        if (match?.params.id !== undefined) {
            (async () => {
                setIsLoading(true);
                await getLeadById(match?.params.id);
                setIsLoading(false);
            })();
        }
    }, []);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        if (parseInt(status) === 3) {
            if (!remark) {
                toast.warning("Remark is required");
                return false
            }

            if (remark.length < 30) {
                toast.warning("Remark must be minimum 30 characters long");
                return false
            }
        }

        setIsLoading(true);
        await leadApprovalAction({id: match?.params?.id, status: status, remark: remark});
        setIsLoading(false);
    }

    console.log(leadApprovalResponse)
    useEffect(() => {
        if (leadApprovalResponse?.status === 200) {
            toast.success(leadApprovalResponse?.msg)
            setTimeout(() => {
                window.location.href = `dsm-lead-pending`
            }, 1000)
        } else if (leadApprovalResponse?.status !== undefined && leadApprovalResponse?.status !== 200) {
            toast.warning(leadApprovalResponse?.msg)
        }
    }, [leadApprovalResponse])

    return (
        <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={
                                'View Lead'
                            }
                        />

                        {/*BODY*/}

                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <h1 className="h3 mb-0 text-black-100 hide">Lead</h1>
                            </div>

                            <form>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header"></div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                value={leadById?.data?.account_name}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Business Name
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>

                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                value={leadById?.data?.address}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Address
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        {leadById?.data?.meta_data && leadById?.data?.meta_data[0] && Object.keys(leadById?.data?.meta_data[0]).length > 0 &&
                                                            Object.keys(leadById?.data?.meta_data[0]).map((val) => {
                                                                return (
                                                                    <>
                                                                        {val !== 'state_id' && val !== 'geo_city_id' && val !== 'business_photo' &&
                                                                            <div className="col-md-6 float-field ">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control form-control-user"
                                                                                    required={true}
                                                                                    value={leadById?.data?.meta_data[0][val]}
                                                                                />

                                                                                <label className="large-label float-lb">
                                                                                    {val}
                                                                                    <i className="bi bi-asterisk astrick-icon"></i>
                                                                                </label>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                        {leadById?.data?.meta_data && leadById?.data?.meta_data[0] && leadById?.data?.meta_data[0]['business_photo'] &&
                                                            leadById?.data?.meta_data[0]['business_photo'].map(val => {
                                                                return (
                                                                    <>
                                                                        <img src={val} alt={'business_doc'}
                                                                             style={{width: '200px'}}/>
                                                                    </>
                                                                )
                                                            })
                                                        }

                                                        {leadById?.data?.lead_poc_details && leadById?.data?.lead_poc_details.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div className="col-md-12">
                                                                        <div
                                                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                                        </div>
                                                                        <div className="mb-4 bg-white">
                                                                            <div
                                                                                className=" card-header bg-lightGreen-active">
                                                                                POC Details
                                                                            </div>
                                                                            <div className="card-body">
                                                                                <div className="user">
                                                                                    <div className="form-group row">
                                                                                        <div
                                                                                            className="col-md-6 float-field ">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                required
                                                                                                value={val?.name}
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Poc
                                                                                                Name{" "}
                                                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-sm-6 float-field">
                                                                                            <input
                                                                                                type="email"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                required
                                                                                                value={val?.email}
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Email
                                                                                                Id{" "}
                                                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-sm-6 float-field">
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                required
                                                                                                value={val?.number}
                                                                                                pattern={"[1-9]{1}[0-9]{9}"}
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Mobile
                                                                                                Number{" "}
                                                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-sm-6 float-field">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                required
                                                                                                value={val?.designation}
                                                                                                pattern={"[1-9]{1}[0-9]{9}"}
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Designation{" "}
                                                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}

                                                        {parseInt(leadById?.data?.status) === 1 &&
                                                            <>
                                                                <div
                                                                    className="col-sm-6 mtk-075 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder=" Remarks"
                                                                        onChange={(e) => {
                                                                            setRemark(e.target.value)
                                                                        }}
                                                                        id="validationCustom01"
                                                                        rows="4"
                                                                        cols="50"
                                                                        required={true}
                                                                    />
                                                                    <label
                                                                        className="large-label float-lb">
                                                                        {/*Description*/}
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-12 mt-4 d-flex">
                                                                    <div className="col-sm-6">
                                                                        <button
                                                                            className="btn btn-primary btn-user btn-block submit-btn"
                                                                            style={{backgroundColor: "#60a917"}}
                                                                            onClick={(e) => handleSubmit(e, 2)}
                                                                        >
                                                                            Approve
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <button
                                                                            className="btn btn-primary btn-user btn-block submit-btn"
                                                                            style={{backgroundColor: "#d94d40"}}
                                                                            onClick={(e) => handleSubmit(e, 3)}
                                                                        >
                                                                            Reject
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <BottomMenu/>
            </div>
            {/* section ends */}
        </>
    );
};
export default ApprovalDsmLead;
